import { FieldFilterType } from "../../../../base/types"
import { useAuth } from "../../../../../modules/auth"
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi"
import { useState } from "react"

export const useGetAutoApprovalService = () => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [autoApprovalServiceId, setAutoApprovalServiceId] = useState<string>()
    const [gatePassServiceId, setGatePassServiceId] = useState<string>()

    const getAutoApprovalServiceIds = (): Promise<{ autoApprovalServiceId: string, gatePassServiceId: string }> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.userId || '',
            portalId: siteId || '',
            tableId: "slcm_configurator",
            fieldList: ["edtec365_autoapprovalservice", "edtec365_gatepassservice"],
            filters: [{
                group: 0, filters: [
                    { field: "slcm_name", type: FieldFilterType.Const, value: "Gate Pass" }
                ]
            }]
        })
            .unwrap()
            .then((data) => {
                if (data.records.length > 0) {
                    const autoApprovalServiceId = data.records[0]["edtec365_autoapprovalservice"] as string
                    const gatePassServiceId = data.records[0]["edtec365_gatepassservice"] as string

                    // Set the service IDs to state
                    setAutoApprovalServiceId(autoApprovalServiceId)
                    setGatePassServiceId(gatePassServiceId)

                    // Return both service IDs
                    return Promise.resolve({ autoApprovalServiceId, gatePassServiceId })
                }

                return Promise.reject('No active request found');
            })
            .catch(error => {
                console.error(error)
                return Promise.reject(error)
            });
    }

    return { getAutoApprovalServiceIds, autoApprovalServiceId, gatePassServiceId }
}
